import Moment from "moment";
import moment from "moment";
import Labels from "../constant/labels";
import UtilBloc from "../../bloc/util_bloc";
import { Util } from "reactstrap";
import FormBloc from "../../bloc/forms_bloc";

export const getGenderBasedOnNRIC = (value) => {
  let gender = "";
  if (parseInt(value) % 2 === 0) {
    gender = "Female";
  } else {
    gender = "Male";
  }
  return gender;
};

export const occupationClassValidation = (oldValue, newValue) => {
  if (parseInt(oldValue) > parseInt(newValue)) {
    return Labels.ERROR_OCCUPATION_CLASS;
  } else {
    return "";
  }
};

export const generalValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_VALUE;
  } else {
    return "";
  }
};

export const anbValidation = (value, id) => {
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_ANB;
  } else {
    return "";
  }
};

export const countryCodeMobileNumberValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_COUNTRY_CODE_MOBILE;
  } else {
    return "";
  }
};

export const financialAccountNoValidation = (value, id) => {
  // id=id.replace("_"," ")
  /*  if (UtilBloc.isNullOrEmpty(value)) {
     return Labels.ERROR_EMPTY_VALUE;
   } else */
  if (value && value.length != 16) {
    return Labels.LBL_ERR_FINANCIAL_ACCOUNT_NO;
  } else {
    return "";
  }
};

export const financingPercentageValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_VALUE;
  } else if (value > 100) {
    return Labels.LBL_ERROR_FINANCING_PERCENTAGE;
  } else {
    return "";
  }
};

export const assuredBankRateValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERRO_EMPTY_ASSUMED_BANK_RATE;
  } else if (UtilBloc.isExceed18Percent(value)) {
    return Labels.ERROR_ASSURED_BANK_RATE;
  } else {
    return "";
  }
};

export const stateValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_PROVIDE_STATE;
  } else {
    return "";
  }
};

export const stateValidation2 = (value, id) => {
  if (value == null || value == "") {
    return Labels.ERROR_PROVIDE_STATE;
  } else {
    return "";
  }
};

export const countryValidation = (value, id) => {
  if (value == null || value == "") {
    return Labels.ERROR_PROVIDE_COUNRTY;
  } else {
    return "";
  }
};

export const categoryOfBankValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_CATEGORY_OF_BANK;
  } else {
    return "";
  }
};

export const financingBankValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_BANK_NAME;
  } else {
    return "";
  }
};

export const yearsOfSmokedValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_YEARS_SMOKED;
  } else {
    return "";
  }
};

export const stickPerDayValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_STICKS_PER_DAY;
  } else {
    return "";
  }
};

export const personalStatementValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_CURRENTLY_LIVING;
  } else {
    return "";
  }
};

export const smokingStatusValidation = (value, id) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROIVDE_SMOKING_STATUS;
  } else {
    return "";
  }
};

export const typeOfSmokingValidation = (value, id) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_TYPE_OF_SMOKING;
  } else {
    return "";
  }
};

export const weightValidation = (value, id) => {
  if (
    value.trim() === "." ||
    value.trim() === "0" ||
    value == 0 ||
    /^\d{1}$/.test(value.trim())
  ) {
    return Labels.LBL_ERROR_INVALID_WEIGHT;
  } else if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_WEIGHT;
  } else {
    return "";
  }
};

export const heightValidation = (value, id) => {
  if (
    value.trim() === "." ||
    value.trim() === "0" ||
    value == 0 ||
    /^\d{1}$/.test(value.trim())
  ) {
    return Labels.LBL_ERROR_INVALID_HEIGHT;
  } else if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_HEIGHT;
  } else {
    return "";
  }
};

export const titleValidation = (currentSalutation, gender) => {
  if (
    currentSalutation !== null &&
    currentSalutation !== "" &&
    currentSalutation != gender &&
    currentSalutation !== "both"
  ) {
    return Labels.LBL_ERROR_PROVIDE_TITLE;
  } else {
    return "";
  }
};

export const maritalStatusValidation = (maritalStatus) => {
  if (maritalStatus == null || maritalStatus == "") {
    return Labels.LBL_ERROR_PROVIDE_MARITAL_STATUS;
  } else {
    return "";
  }
};

export const isMalaysianValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_ISMALAYSIAN;
  } else {
    return "";
  }
};

export const occupationClassValidation2 = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_OCCUPATION_CLASS;
  } else {
    return "";
  }
};

export const natureOfBusinessValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_NOB;
  } else {
    return "";
  }
};

export const occupationValidation = (value) => {
  if (value == null || value == "") {
    return Labels.LBL_ERROR_PROVIDE_OCCUPATION;
  } else {
    return "";
  }
};

export const raceValidation = (race) => {
  if (race == null || race == "") {
    return Labels.LBL_ERROR_PROVIDE_RACE;
  } else {
    return "";
  }
};

export const religionValidation = (religion) => {
  if (religion == null || religion == "") {
    return Labels.LBL_ERROR_PROVIDE_RELIGION;
  } else {
    return "";
  }
};

export const currentyLivingValidation = (currentLiving) => {
  if (currentLiving == null || currentLiving == "") {
    return Labels.LBL_ERROR_PROVIDE_CURRENTLY_LIVING;
  } else {
    return "";
  }
};

export const newPasswordValidation = (value, id) => {
  // Regex
  const newPasswordRules = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,}$/;

  if (newPasswordRules.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const companyNameValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_COMPANY_NAME;
  } else if (
    value.includes("!") ||
    value.includes("$") ||
    value.includes("%") ||
    value.includes("^") ||
    value.includes("*") ||
    value.includes("+") ||
    value.includes("=") ||
    value.includes("|") ||
    value.includes("<") ||
    value.includes("?") ||
    value.includes(`"`) ||
    value.includes("{") ||
    value.includes("}") ||
    value.includes("[") ||
    value.includes("]") ||
    value.includes("_") ||
    value.includes("~")
  ) {
    return Labels.LBL_ERROR_EMPLOYER_OR_COMPANY_NAME_SYMBOL;
  } else {
    return "";
  }
};

export const cityValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_CITY;
  } else {
    return "";
  }
};

export const bankAccountNoValidation = (value, min, max, criteriaType) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_PROVIDE_ACCOUNT_BANK_NUMBER;
  } else if (
    UtilBloc.isMaximumOrMinimumReached(value, min, max) &&
    criteriaType == "to"
  ) {
    let errorLabel = Labels.LBL_ERROR_BANK_NO_RANGE;
    return errorLabel;
  } else if (UtilBloc.isOrCriteria(value, min, max) && criteriaType == "or") {
    let errorLabel = Labels.LBL_ERROR_BANK_NO_OR;
    return errorLabel;
  } else if (value.length != min && min == max) {
    let errorLabel = Labels.LBL_ERROR_BANK_NO_FIXED;
    return errorLabel;
  } else {
    return "";
  }
};

export const dateOfBirthValidation = (value, id) => {
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_DATE_OF_BIRTH;
  } else if (UtilBloc.isCurrentDateBetween19And60YearsAgoNewNRIC(value)) {
    if (UtilBloc.isFutureDate(value)) {
      return Labels.ERROR_DATE_OF_BIRTH_FUTURE_DATE;
    } else {
      return Labels.ERROR_DATE_OF_BIRTH_BETWEEN_19_AND_60;
    }
  } else {
    return "";
  }
};

export const dateOfBirthValidationNewNRIC = (value, id) => {
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_DATE_OF_BIRTH;
  } else if (UtilBloc.isCorrectFormatDate(value)) {
    return Labels.ERROR_INCORRECT_FORMAT_DATE_OF_BIRTH;
  } else if (UtilBloc.isCurrentDateBetween19And60YearsAgoNewNRIC(value)) {
    if (UtilBloc.isFutureDateNewNRIC(value)) {
      return Labels.ERROR_DATE_OF_BIRTH_FUTURE_DATE;
    } else {
      return Labels.ERROR_DATE_OF_BIRTH_BETWEEN_19_AND_60;
    }
  } else {
    return "";
  }
};

export const contributionTypeValidation = (value, id) => {
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_CONTRIBUTION_TYPE;
  } else {
    return "";
  }
};

export const dateOfQuotationValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_DATE_OF_QUOTATION;
  } else {
    return "";
  }
};

export const bankReferenceValidation = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.ERROR_EMPTY_BANK_REFERENCE_NO;
  } else {
    return "";
  }
};

export const otherNRICValidation = (name) => {
  if (name === "") {
    return Labels.ERROR_EMPTY_OTHER_ID_NO;
  } else if (
    name.includes("!") ||
    name.includes("#") ||
    name.includes("$") ||
    name.includes("%") ||
    name.includes("^") ||
    name.includes("*") ||
    name.includes("+") ||
    name.includes("=") ||
    name.includes("|") ||
    name.includes("<") ||
    name.includes(">") ||
    name.includes("?") ||
    name.includes(`"`) ||
    name.includes(",") ||
    name.includes(":") ||
    name.includes(";") ||
    name.includes("{") ||
    name.includes("}") ||
    name.includes("[") ||
    name.includes("]") ||
    name.includes("~") ||
    name.includes("_") ||
    name.includes("`")
  ) {
    return Labels.ERR_OTHER_ID_NO;
  } else {
    return "";
  }
};

export const nameValidation = (name, isCompany = false) => {
  if (name === "" || name === null) {
    return 'Please confirm the Name are entered correctly.';
  } else if (name.length < 3) {
    return 'Please confirm the Name are entered correctly.';
  } else if (name.charAt(0) === " ") {
    return 'Please confirm the Name are entered correctly.';
  } else if (name.includes("  ")) {
    return 'Please confirm the Name are entered correctly.';
  } else if (/(\s-|-\s)/.test(name)) {
    return 'Please confirm the Name are entered correctly.';
  } else if (isCompany ? /[!#%*;?~{}]/.test(name) : /[0-9!#%*;?~{}]/.test(name)) {
    return 'Invalid format';
  } else if (name.charAt(name.length - 1) === " ") {
    return 'Please confirm the Name are entered correctly.';
  } else if (/(.)\1\1\1/.test(name)) {
    return 'Invalid format';
  }
};

export const isUpper = (str) => {
  return !/[a-z]/.test(str) && /[A-Z]/.test(str);
};

//Check if value contain number only
export const isContainNumberOnly = (value) => {
  return /^\d+$/.test(value);
}

//Check if value contain number only
export const validateDecimal = (input) => {
  const regex = /^[0-9]*\.?[0-9]*$/;
  return regex.test(input);
}

export const numberValidation = (value) => {
  if (value == "" || value == null) {
    return 'Fill in the required field.';
  } else if (!isContainNumberOnly(value)) {
    return 'Please filled in number only.'
  }
};

export const decimalNumberValidation = (value) => {
  if (value == "" || value == null) {
    return 'Fill in the required field.';
  } else if (!validateDecimal(value)) {
    return 'Please filled in number only.'
  }
};

export const nricValidation = (value) => {
  if (value == "" || value == null) {
    return 'Fill in the required field.';
  } else if (!isContainNumberOnly(value)) {
    return 'Please provide a valid ID Number'
  } else if (value.length < 12 || value.length > 12) {
    return 'Please provide a valid ID Number';
  }
};

export const isDate = (date) => {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

export const isDateInCalendar = (date) => {
  //console.log("VALUEDATE",date)
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date));
};

export const getAgeFromDOB = (dob) => {
  //console.log("DOBBBBBINSIDE",dob)
  let currentMonthDay = Moment(new Date()).format("MM/DD");
  let currentYear = Moment(new Date()).format("YYYY");
  let dobYear = dob.split("-")[2];
  let yearsold = 0;
  let birthyear = parseInt(dobYear);
  let yearDiff = currentYear - birthyear;
  // console.log("dob unformatted", dob)
  // console.log("Current Month dat", currentMonthDay)
  let formattedDate = moment(dob, "DD-MM-YYYY").format("MM/DD");

  if (currentMonthDay >= formattedDate) {
    yearDiff = yearDiff + 1;
  }
  yearsold = yearDiff;
  return yearsold;
};

export const getBirthDateBasedOnNRIC = (value) => {
  if (value.length > 5) {
    const Year = value.substring(0, 2);
    const Month = value.substring(2, 4);
    const Day = value.substring(4, 6);

    var cutoff = new Date().getFullYear() - 2000;
    var dob =
      "DOB: " + (Year > cutoff ? "19" : "20") + Year + "/" + Month + "/" + Day;
    return dob;

    //TODO: Validation for age range
  }
};

export const getBirthDateBasedOnNRIC1 = (value) => {
  if (value.length > 5) {
    const Year = value.substring(0, 2);
    const Month = value.substring(2, 4);
    const Day = value.substring(4, 6);

    var cutoff = new Date().getFullYear() - 2000;
    var dob = (Year > cutoff ? "19" : "20") + Year + "/" + Month + "/" + Day;
    return dob;

    //TODO: Validation for age range
  }
};

export const getBirthDateBasedOnNRIC2 = (value) => {
  if (value.length > 5) {
    const Year = value.substring(0, 2);
    const Month = value.substring(2, 4);
    const Day = value.substring(4, 6);

    var cutoff = new Date().getFullYear() - 2000;
    var dob = Day + "-" + Month + "-" + (Year > cutoff ? "19" : "20") + Year;
    return dob;

    //TODO: Validation for age range
  }
};

export const postCodeValidation = (value) => {
  let statesData = {};
  let citiesData = {};
  let cities = [];

  statesData = FormBloc.getStateSelections();
  citiesData = FormBloc.getCitySelections();

  cities = citiesData;

  let arr = null;
  for (let i = 0; i < cities.length; i++) {
    if (cities[i].postCode == value) {
      arr = cities[i];
      break;
    }
  }

  if (arr == null) {
    if (value == "") {
      return "Please enter postcode";
    } else {
      return "Postcode is not valid";
    }
  } else {
    return "";
  }
};

export const postCodeValidation2 = (value, id) => {
  // id=id.replace("_"," ")
  if (UtilBloc.isNullOrEmpty(value)) {
    return Labels.LBL_ERROR_POSTAL_CODE;
  }
  // else if (value.includes("  ")) {
  //   return "This field cannot contain double spacing between words."/* Labels.ERROR_POSTCODE_VALIDATION_DOUBLE_SPACE */;
  // }
  else {
    return "";
  }
};

export const employerNameValidation = (name) => {
  if (name === "") {
    return Labels.ERR_NAME_1;
  } else if (/\d/.test(name)) {
    return Labels.ERR_NAME_2;
  } else if (name.charAt(0) === " " || name.charAt(name.length - 1) === " ") {
    return Labels.ERR_NAME_3;
  } else if (name.length < 3) {
    return Labels.ERR_NAME_4;
  } else if (name.includes("  ")) {
    return Labels.ERR_NAME_5;
  } else if (
    name.includes("!") ||
    name.includes("#") ||
    name.includes("$") ||
    name.includes("%") ||
    name.includes("^") ||
    name.includes("&") ||
    name.includes("*") ||
    name.includes("(") ||
    name.includes(")") ||
    name.includes("_") ||
    name.includes("+") ||
    name.includes("=") ||
    name.includes("|") ||
    name.includes("<") ||
    name.includes(">") ||
    name.includes("?") ||
    name.includes(`"`) ||
    name.includes(",") ||
    name.includes(":") ||
    name.includes(";") ||
    name.includes("{") ||
    name.includes("}") ||
    name.includes("[") ||
    name.includes("]") ||
    name.includes("~") ||
    name.includes("`")
  ) {
    return Labels.ERR_NAME_6;
  } else if (/(.)\1\1\1/.test(name)) {
    return Labels.ERR_NAME_7;
  }
};

export const addressValidation = (address) => {
  if (address === "") {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_1;
  } else if (address.length < 2) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_2;
  } else if (
    address.includes("!") ||
    // address.includes("#") ||
    address.includes("$") ||
    address.includes("%") ||
    address.includes("^") ||
    // address.includes("&") ||
    address.includes("*") ||
    // address.includes("(") ||
    // address.includes(")") ||
    // address.includes("_") ||
    address.includes("+") ||
    address.includes("=") ||
    address.includes("|") ||
    address.includes("<") ||
    // address.includes(">") ||
    address.includes("?") ||
    address.includes(`"`) ||
    // address.includes(",") ||
    // address.includes(":") ||
    // address.includes(";") ||
    address.includes("{") ||
    address.includes("}") ||
    address.includes("[") ||
    address.includes("]") ||
    address.includes("_") ||
    address.includes("~")
    // address.includes("`")
  ) {
    return Labels.LBL_ERROR_ADDRESS_SYMBOL;
  } else if (address.includes("  ")) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_3;
  } else if (
    address.charAt(0) === " " ||
    address.charAt(address.length - 1) === " "
  ) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_4;
  }
};

export const addressValidationEmployer = (address) => {
  if (address === "") {
    return Labels.LBL_ERROR_EMPLOYER_ADDRESS;
  } else if (address.length < 2) {
    return Labels.ERROR_EMPLOYER_ADDRESS_2;
  } else if (
    address.includes("!") ||
    address.includes("$") ||
    address.includes("%") ||
    address.includes("^") ||
    address.includes("*") ||
    address.includes("+") ||
    address.includes("=") ||
    address.includes("|") ||
    address.includes("<") ||
    address.includes("?") ||
    address.includes(`"`) ||
    address.includes("{") ||
    address.includes("}") ||
    address.includes("[") ||
    address.includes("]") ||
    address.includes("_") ||
    address.includes("~")
  ) {
    return Labels.LBL_ERROR_ADDRESS_SYMBOL;
  } else if (address.includes("  ")) {
    return Labels.ERROR_EMPLOYER_ADDRESS_3;
  } else if (
    address.charAt(0) === " " ||
    address.charAt(address.length - 1) === " "
  ) {
    return Labels.ERROR_EMPLOYER_ADDRESS_4;
  }
};

export const residentialAddressValidation = (address) => {
  if (address === "") {
    return "Residential Address cannot be empty.";
  } else if (address.length < 2) {
    return "Residential Address cannot be less than 1 character.";
  } else if (address.includes("  ")) {
    return "Residential Address cannot contain double spacing between words.";
  } else if (
    address.charAt(0) === " " ||
    address.charAt(address.length - 1) === " "
  ) {
    return "First/Last character of residential address cannot be blank.";
  }
};

export const addressValidationCorrespondence23 = (address) => {
  if (address.length < 1) {
    return "" /* "Correspondence Address cannot be less than 1 character." */;
  }
  if (address === "") {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_1;
  } else if (address.length < 2) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_2;
  } else if (
    address.includes("!") ||
    address.includes("$") ||
    address.includes("%") ||
    address.includes("^") ||
    address.includes("*") ||
    address.includes("_") ||
    address.includes("+") ||
    address.includes("=") ||
    address.includes("|") ||
    address.includes("<") ||
    address.includes("?") ||
    address.includes(`"`) ||
    address.includes("{") ||
    address.includes("}") ||
    address.includes("[") ||
    address.includes("]") ||
    address.includes("~")
  ) {
    return Labels.LBL_ERROR_ADDRESS_SYMBOL;
  } else if (address.includes("  ")) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_3;
  } else if (
    address.charAt(0) === " " ||
    address.charAt(address.length - 1) === " "
  ) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_4;
  } else if (address.includes("  ")) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_3;
  } else if (
    address.charAt(0) === " " ||
    address.charAt(address.length - 1) === " "
  ) {
    return Labels.ERROR_CORRESPONDENCE_ADDRESS_4;
  }
};

export const emailValidation = (value) => {
  const reg =
    /^[a-zA-Z0-9&(),./_\-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

  if (value.length === 0) {
    return Labels.ERROR_EMAIL_ADDRESS_1;
  } else if (value.length > 60) {
    return Labels.ERROR_EMAIL_ADDRESS_2;
  } else if (value.charAt(0) === " ") {
    return Labels.ERROR_EMAIL_ADDRESS_3;
  } else if (!reg.test(value)) {
    return Labels.ERROR_EMAIL_ADDRESS_4;
  } else if (value.charAt(value.length - 1) === " ") {
    return Labels.ERROR_EMAIL_ADDRESS_5;
  }
};

export const phoneNumberValidation = (value) => {
  if (value == "" || value == null) {
    return 'Fill in required data.';
  }
  else if (!isContainNumberOnly(value)) {
    return 'Please filled in number only.';
  }
  else if (value.includes('-')) {
    return 'Phone number should be 01XXXXXXXX.'
  }
  // Temporary disabled
  // else if (value.charAt(3) != "1") {
  //   return Labels.ERROR_MOBILE_NUMBER;
  // }
  // else if (value.charAt(0) == "0") {
  //   return Labels.ERROR_MOBILE_NUMBER;
  // } 
  else if (value.substring(0, 2) == "11" && value.length < 9) {
    return Labels.ERROR_MOBILE_NUMBER;
  } else if (
    (value.substring(0, 2) == "10" ||
      value.substring(0, 2) == "12" ||
      value.substring(0, 2) == "13" ||
      value.substring(0, 2) == "14" ||
      value.substring(0, 2) == "15" ||
      value.substring(0, 2) == "16" ||
      value.substring(0, 2) == "17" ||
      value.substring(0, 2) == "18" ||
      value.substring(0, 2) == "19") &&
    value.length < 9
  ) {
    return Labels.ERROR_MOBILE_NUMBER;
  }
};

export const officeNumberValidation = (value) => {
  if (value.charAt(0) == "0") {
    return Labels.LBL_ERR_OFFICE_NUMBER_MALAYSIA;
  }
};

export const mobilePhoneNumberMalaysiaValidation = (value) => {
  value = value.replaceAll("-", "");
  if (value === "") {
    return Labels.LBL_ERROR_PROVIDE_MOBILE_NUMBER;
  }
  // Temporary disabled
  // else if (value.charAt(3) != "1") {
  //   return Labels.ERROR_MOBILE_NUMBER;
  // }
  else if (value.charAt(0) == "0") {
    return Labels.LBL_ERR_MOBILE_NUMBER_MALAYSIA;
  } else if (value.substring(0, 2) == "11" && value.length < 9) {
    return Labels.ERROR_MOBILE_NUMBER;
  } else if (
    (value.substring(0, 2) == "10" ||
      value.substring(0, 2) == "12" ||
      value.substring(0, 2) == "13" ||
      value.substring(0, 2) == "14" ||
      value.substring(0, 2) == "15" ||
      value.substring(0, 2) == "16" ||
      value.substring(0, 2) == "17" ||
      value.substring(0, 2) == "18" ||
      value.substring(0, 2) == "19") &&
    value.length < 9
  ) {
    return Labels.ERROR_MOBILE_NUMBER;
  } else if (value.length < 9) {
    return Labels.ERROR_MOBILE_NUMBER;
  }
};

export const officePhoneNumberMalaysiaValidation = (value) => {
  value = value.replaceAll("-", "");
  if (value == "") {
    return Labels.LBL_ERROR_PROVIDE_OFFICE_NUMBER;
  } else if (
    (value.substring(0, 2) == "10" ||
      value.substring(0, 2) == "12" ||
      value.substring(0, 2) == "13" ||
      value.substring(0, 2) == "14" ||
      value.substring(0, 2) == "15" ||
      value.substring(0, 2) == "16" ||
      value.substring(0, 2) == "17" ||
      value.substring(0, 2) == "18" ||
      value.substring(0, 2) == "19") &&
    value.length < 8
  ) {
    return Labels.ERROR_OFFICE_PHONE_NUMBER;
  } else if (value.charAt(0) == "0") {
    return Labels.LBL_ERR_OFFICE_NUMBER_MALAYSIA;
  } else if (value.length < 8) {
    return Labels.ERROR_OFFICE_PHONE_NUMBER;
  }
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
